export default __webpack_public_path__ + "static/media/img-ovato-coin-front-new.175b375d.jpg";